module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/title/title-transportation-8c4a4762e8018daacedbad19bec229cc.svg&quot;;"